module.exports = __webpack_public_path__ + "img/user.4c5287ad.png";